import './style.scss';
import { InputAdvisability } from 'views/components/molecules/establishes/inputAdvisability';
import {
  DepositAccountFormikType,
  DEPOSIT_TYPE,
  getDepositType,
  FormErrorScrollTarget,
} from 'views/utils/accountEstablish';
import { Button, ButtonProps } from 'views/components/atoms/button';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishText } from 'views/components/atoms/establishes/text';
import { EstablishLink } from 'views/components/atoms/establishes/link';

type DepositAccountTemplateType = {
  formik: DepositAccountFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
    confirmButtonProps: ButtonProps;
    isPrevPageConfirm: boolean;
  };
};

export const DepositAccountTemplate = ({ formik, buttonProps }: DepositAccountTemplateType) => {
  return (
    <>
      <div className="establishWrapper">
        {!!formik.errors.isYuchoBank && <FormErrorScrollTarget />}
        <InputAdvisability
          title="指定預金口座としてゆうちょ銀行をご利用されますか？"
          name="isYuchoBank"
          batchDangerWord="必須"
          agreeText="はい"
          denialText="いいえ"
          agreeValue="true"
          denialValue="false"
          checked={formik.values.isYuchoBank ?? undefined}
          onChange={(checked) => formik.setFieldValue('isYuchoBank', checked)}
          isEnabled={!!formik.errors.isYuchoBank}
          errorText={formik.errors.isYuchoBank}
        />
      </div>
      {formik.values.isYuchoBank !== null && formik.values.isYuchoBank && (
        <div className="establishWrapper hiddenBg">
          <div className="establishWrapper_announce">
            <h1>ゆうちょ銀行口座</h1>
            <span>
              ゆうちょ銀行の口座をご登録の場合には、以下のゆうちょ銀行HPのリンク先から、振込用の店名・預金種目・口座番号をお調べいただいた上で、ご入力ください
              <br />
              <EstablishLink
                linkTitle="https://www.jp-bank.japanpost.jp/kojin/sokin/furikomi/kouza/kj_sk_fm_kz_1.html"
                linkUrl="https://www.jp-bank.japanpost.jp/kojin/sokin/furikomi/kouza/kj_sk_fm_kz_1.html"
              />
            </span>
          </div>
          <div className="inputWrapper">
            {!!formik.errors.bankCodeOfYucho && <FormErrorScrollTarget />}
            <EstablishHeader headerTitle={'銀行コード'} batchDangerWord="必須" />
            <EstablishText
              inputType="tel"
              inputValue={formik.values.bankCodeOfYucho ?? undefined}
              setInputValue={(e) => formik.setFieldValue('bankCodeOfYucho', e.target.value)}
              placeholder="例:0001"
            />
            <span className="bankLabel">{formik.values.bankNameOfYucho}</span>
            <EstablishError isEnabled={!!formik.errors.bankCodeOfYucho} errorText={formik.errors.bankCodeOfYucho} />
          </div>
          <div className="inputWrapper">
            {!!formik.errors.branchCodeOfYucho && <FormErrorScrollTarget />}
            <EstablishHeader headerTitle={'店番号'} batchDangerWord="必須" />
            <EstablishText
              inputType="tel"
              inputValue={formik.values.branchCodeOfYucho ?? undefined}
              setInputValue={(e) => formik.setFieldValue('branchCodeOfYucho', e.target.value)}
              placeholder="例:001"
            />
            <span className="bankLabel">{formik.values.branchNameOfYucho}</span>
            <EstablishError isEnabled={!!formik.errors.branchCodeOfYucho} errorText={formik.errors.branchCodeOfYucho} />
          </div>
          <div className="inputWrapper">
            {!!formik.errors.accountNumberOfYucho && <FormErrorScrollTarget />}
            <EstablishHeader headerTitle={'口座番号'} batchDangerWord="必須" />
            <EstablishText
              inputType="tel"
              inputValue={formik.values.accountNumberOfYucho ?? undefined}
              setInputValue={(e) => formik.setFieldValue('accountNumberOfYucho', e.target.value)}
              placeholder="例:1234567"
            />
            <span className="establishWrapper_description">※口座名義は本登録と同じ本人名義に限ります</span>
            <EstablishError
              isEnabled={!!formik.errors.accountNumberOfYucho}
              errorText={formik.errors.accountNumberOfYucho}
            />
          </div>
          {!!formik.errors.depositFormOfYucho && <FormErrorScrollTarget />}
          <InputAdvisability
            title="預金種目"
            name="depositFormOfYucho"
            batchDangerWord="必須"
            agreeText="普通預金"
            denialText="貯蓄預金"
            agreeValue="true"
            denialValue="false"
            checked={getDepositType(formik.values.depositFormOfYucho)}
            onChange={(checked) =>
              formik.setFieldValue('depositFormOfYucho', checked ? DEPOSIT_TYPE.NORMAL : DEPOSIT_TYPE.SAVING)
            }
            isEnabled={!!formik.errors.depositFormOfYucho}
            errorText={formik.errors.depositFormOfYucho}
          />
        </div>
      )}
      {formik.values.isYuchoBank !== null && !formik.values.isYuchoBank && (
        <div className="establishWrapper hiddenBg">
          <div className="establishWrapper_announce">
            <h1>指定預金口座</h1>
          </div>

          <div className="inputWrapper">
            {!!formik.errors.bankCode && <FormErrorScrollTarget />}
            <EstablishHeader headerTitle={'銀行コード'} batchDangerWord="必須" />
            <EstablishText
              inputType="tel"
              inputValue={formik.values.bankCode ?? undefined}
              setInputValue={(e) => formik.setFieldValue('bankCode', e.target.value)}
              placeholder="例:0001"
            />
            <span className="bankLabel">{formik.values.bankName}</span>
            <EstablishError isEnabled={!!formik.errors.bankCode} errorText={formik.errors.bankCode} />
          </div>
          <div className="inputWrapper">
            {!!formik.errors.branchCode && <FormErrorScrollTarget />}
            <EstablishHeader headerTitle={'店番号'} batchDangerWord="必須" />
            <EstablishText
              inputType="tel"
              inputValue={formik.values.branchCode ?? undefined}
              setInputValue={(e) => formik.setFieldValue('branchCode', e.target.value)}
              placeholder="例:001"
            />
            <span className="bankLabel">{formik.values.branchName}</span>
            <EstablishError isEnabled={!!formik.errors.branchCode} errorText={formik.errors.branchCode} />
          </div>
          <div className="inputWrapper">
            {!!formik.errors.accountNumber && <FormErrorScrollTarget />}
            <EstablishHeader headerTitle={'口座番号'} batchDangerWord="必須" />
            <EstablishText
              inputType="tel"
              inputValue={formik.values.accountNumber ?? undefined}
              setInputValue={(e) => formik.setFieldValue('accountNumber', e.target.value)}
              placeholder="例:1234567"
            />
            <span className="establishWrapper_description">※口座名義は本登録と同じ本人名義に限ります</span>
            <EstablishError isEnabled={!!formik.errors.accountNumber} errorText={formik.errors.accountNumber} />
          </div>
          {!!formik.errors.depositForm && <FormErrorScrollTarget />}
          <InputAdvisability
            title="預金種目"
            name="depositForm"
            batchDangerWord="必須"
            agreeText="普通（総合）"
            denialText="当座"
            agreeValue="true"
            denialValue="false"
            checked={getDepositType(formik.values.depositForm)}
            onChange={(checked) =>
              formik.setFieldValue('depositForm', checked ? DEPOSIT_TYPE.NORMAL : DEPOSIT_TYPE.SAVING)
            }
            isEnabled={!!formik.errors.depositForm}
            errorText={formik.errors.depositForm}
          />
        </div>
      )}

      {buttonProps && (
        <div className="establishWrapper">
          {buttonProps.isPrevPageConfirm ? (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.confirmButtonProps} />
            </div>
          ) : (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.prevButtonProps} />
              <Button {...buttonProps.nextButtonProps} />
            </div>
          )}
        </div>
      )}
    </>
  );
};
